import { Link, Text } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import translation from 'src/components/translation';

import useShowAdvertisementAgreement from 'src/components/AdvertisementAgreement/useShowAdvertisementAgreement';

const TrlKeys = {
    linkOne: 'settings.subscribe.applicant.checkbox.part.1',
    linkTwo: 'settings.subscribe.applicant.checkbox.part.2',
};

interface AgreementTextProps {
    text: string;
    articleId: number;
}

const AgreementHint: TranslatedComponent<AgreementTextProps> = ({ trls, text, articleId }) => {
    const showAdvertisementAgreement = useShowAdvertisementAgreement();

    if (!showAdvertisementAgreement) {
        return null;
    }

    return (
        <Text typography="label-4-regular" style="secondary">
            {formatToReactComponent(text, {
                '{0}': (
                    <Link
                        Element={SPALink}
                        to={`/article/${articleId}`}
                        target="_blank"
                        typography="label-4-regular"
                        inline
                    >
                        {trls[TrlKeys.linkOne]}
                    </Link>
                ),
                '{1}': (
                    <Link
                        Element={SPALink}
                        to={`/article/${articleId}#clause1`}
                        target="_blank"
                        typography="label-4-regular"
                        inline
                    >
                        {trls[TrlKeys.linkTwo]}
                    </Link>
                ),
            })}
        </Text>
    );
};

export default translation(AgreementHint);
